import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text } from '../../../components/presentation/Text'
import { usePlaceType } from '../_context/PlaceTypeContext'
import { useSendFormActions, useSendFormState } from './_form/SendFormHandler'
import { useSendFormRequest } from './_requests/sendForm.request'
import Button from '../../../components/actions/Button'
import FieldSelect from '../../../containers/fields/FieldSelect'
import FlexGrid from '../../../components/structure/FlexGrid'
import Form from '../../../components/form/Form'
import FormItem from '../../../components/form/FormItem'
import FormSelect from '../../../containers/forms/select/FormSelect'
import Separator from '../../../components/helpers/Separator'

const SendFormForm = () => {
  const { t } = useTranslation(['sendForm', 'common'])
  const type = usePlaceType()
  const form = useSendFormState()
  const { closeSendFormModal, handleChange } = useSendFormActions()
  const [save, { loading, error, fieldErrors }] = useSendFormRequest(form, closeSendFormModal)

  const commonProps = {
    handleChange,
    form,
    fieldErrors,
    t
  }

  return (
    <Form onSubmit={save}>
      <FormItem field="form" tourStep="selectForm" {...commonProps}>
        <FormSelect value={form.form} placeType={type} onChange={handleChange('form')} />
      </FormItem>

      <FormItem field="placeField" tourStep="selectField" {...commonProps}>
        <FieldSelect
          filter={{
            types: ['email'],
            origins: type
          }}
          selectedLabel={form.placeField}
          onChange={handleChange('placeField')}
        />
      </FormItem>

      <Separator weight={8} />

      <FlexGrid justify="space-between">
        <Text color={COLORS.red}>{error}</Text>

        <Button type="submit" loading={loading} color={COLORS.green}>
          {t('common:send')}
        </Button>
      </FlexGrid>
    </Form>
  )
}

export default SendFormForm
